import IJkelenstamHome from './../classes/home';

export default {
  init() {
    // JavaScript to be fired on the home page
    new IJkelenstamHome();
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};
